import {
	type QuestionInfo,
	type BothFullMissionStates,
	getIsClassQuestionScreenFromMission,
	getClassQuestionFromMission,
	getClassQuestionIdFromMission,
	getStudentClassQuestionResponsesFromMission,
	getCulminatingMomentResultFromMission,
	getConnectedStudents,
} from '@mission.io/mission-toolkit'

type State = ?BothFullMissionStates

export function isClassQuestionScreen(state: State): boolean {
	return getIsClassQuestionScreenFromMission(state)
}

export function getClassQuestion(state: State): ?QuestionInfo {
	return getClassQuestionFromMission(state)
}
export function getStudentClassQuestionResponses(state: State): {
	[studentId: string]: Array<string>,
} {
	return getStudentClassQuestionResponsesFromMission(state)
}
export function getClassQuestionId(state: State): ?string {
	return getClassQuestionIdFromMission(state)
}
export function getCulminatingMomentResult(state: State): ?string {
	return getCulminatingMomentResultFromMission(state)
}

/**
 * getCulminatingMomentVoteCount - get the number of students who have voted for any answer on the current culminating moment.
 *
 * @param {State} state - the fullState of the mission
 *
 * @return {[
 * number, - currentCount - the current number of votes cast
 * number - totalPossibleVoteCount - the total number of votes possible to be cast
 * ]}
 */
export function getCulminatingMomentVoteCount(state: State): [number, number] {
	const responses = getStudentClassQuestionResponsesFromMission(state)
	const students = getConnectedStudents(state, false)

	let count = 0
	let answersFromUnconnectedStudents = 0
	Object.keys(responses).forEach(optionId => {
		count += responses[optionId].length
		responses[optionId].forEach((studentId: string) => {
			if (!students[studentId]) {
				answersFromUnconnectedStudents += 1
			}
		})
	})

	return [count, Object.keys(students).length + answersFromUnconnectedStudents]
}
